import cache from 'services/CacheService';
import lodashOmit from 'lodash.omit';
import _ from 'lodash';
import {statisticsService} from 'services';
import AbstractDataSource from 'store/modules/dashboards/dataGetter/dataSources/AbstractDataSource';
import store from 'store/index';

_.noConflict();

class StatisticsDataSource extends AbstractDataSource {
  constructor ({dashboard, profiles, ...superArgs}) {
    super(superArgs);
    this.dashboard = dashboard;
    this.goalsProfilesMap = this.goalsToProfilesMap(profiles);
    this.service = statisticsService;
  }

  goalsToProfilesMap (profiles) {
    const goalsMap = {};
    for (const profile of profiles) {
      for (const goal of profile.children) {
        goalsMap[goal.id] = profile.id;
      }
    }
    return goalsMap;
  }

  get cacheKey () {
    return `global-dashboards-${this.dashboard.id}`;
  }

  async makeRequest (uniqParams, metrics, dashboardAccounts, dashboardProjects, withVat) {
    const {
      channelIds,
      filteringProjects,
      grouping,
      filterEntities,
      filteringType,
      dateEnd,
      dateStart,
      dateGrouping,
      sorting,
      profiles,
      goals
    } = uniqParams;
    let cancelRequest = true;
    const emptyData = {
      items: [],
      items_total: 0
    };

    if (!_.isEmpty(filteringProjects) && (grouping === 'no' ||
      !_.isEmpty(filterEntities) ||
      !_.isEmpty(channelIds) ||
      !grouping)) {
      cancelRequest = false;
    }

    // cancel request if there are no selected items in grouping or no projects in filtration
    if (cancelRequest) {
      return emptyData;
    }

    const filtering = uniqParams.filtering ? [...uniqParams.filtering] : [];

    // prevent sending wrong filtering
    let _entity = filteringType ? filteringType : grouping;
    if (_entity === 'order_periods') {
      _entity = 'order';
    }

    if (grouping && !_.isEmpty(filterEntities)) {
      filtering.push({
        entity: _entity,
        entities: filterEntities
      });
    }

    let filteringProjectsEntities; // project ids for exact widget
    if (store.getters['projects/currentProject']) {
      filteringProjectsEntities = dashboardProjects;
    } else {
      filteringProjectsEntities = filteringProjects;
    }

    const _grouping = grouping === 'order_periods' ? 'no' : grouping;

    const postData = {
      accountIds: dashboardAccounts,
      projectIds: filteringProjectsEntities ? filteringProjectsEntities : null,
      channelIds,
      dateEnd,
      dateStart,
      dateGrouping,
      grouping: _grouping,
      sorting,
      filtering,
      fields: metrics,
      profiles,
      goals,
      withVat,
      withTotal: false
    };

    const data = await this.service.getDetailedStatistics(postData);

    // if no data is available detailed statistics api method returns one row with zeroes
    if (data.items.length && data.items.length === 1) {
      const values = Object.values(data.items[0]).filter(x => x && x !== '0');

      if (!values.length) {
        return emptyData;
      }
    }

    return data;
  }

  fetch (dsStatisticsParams, filtration, withVat, ignoreCache = false) {
    const metrics = dsStatisticsParams.metric;

    // remove metrics from stat request
    const fetchWidgetParams = lodashOmit(dsStatisticsParams, 'metric');

    return cache.asyncTryCacheOrCall({
      func: async ({metrics, ...uniqParams}) => this.makeRequest(
        uniqParams, metrics, this.dashboardParams.accountsFiltration, this.dashboardParams.projectsFiltration, withVat
      ),
      funcArgs: {metrics, filtration, ...fetchWidgetParams, withVat},
      onProjectLevel: false,
      key: this.cacheKey
    }, ignoreCache);
  }
}

export default StatisticsDataSource;
